import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

import { FetchDeviceConfigurationArgs, fetchDeviceConfiguration } from './fetchDeviceConfiguration';

export function fetchDeviceConfigurationQuery({
  applicationName,
  clientTag,
  clientVersion,
  endpoint,
  platform,
  tag,
  partnerId,
  udid,
}: FetchDeviceConfigurationArgs) {
  return queryClient.fetchQuery({
    queryKey: queryKeys.configuration,
    queryFn: () =>
      fetchDeviceConfiguration({
        applicationName,
        clientTag,
        clientVersion,
        endpoint,
        platform,
        tag,
        partnerId,
        udid,
      }),
    staleTime: Infinity,
    gcTime: Infinity,
  });
}
